/**
 * LoadingFallback — Uses design-system Spinner + layout primitives
 */
import React from 'react';
import { Stack, Text } from '@neuro/design-system';

export interface LoadingFallbackProps {
  message?: string;
}

export function LoadingFallback({ message = 'Loading…' }: LoadingFallbackProps) {
  return (
    <Stack
      align="center"
      justify="center"
      gap={16}
      style={{ minHeight: '300px', width: '100%' }}
    >
      <div className="nc-spinner" aria-hidden="true" />
      <Text size="sm" color="muted">{message}</Text>
    </Stack>
  );
}

export function Spinner({ size = 24 }: { size?: number }) {
  return (
    <div
      className="nc-spinner"
      style={{ width: size, height: size }}
      aria-hidden="true"
    />
  );
}

export default LoadingFallback;
